
export const addSchemaLD = (schema: object) => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
};

export const homePageSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalBusiness",
  "name": "MediMar Medical Market",
  "description": "Home Medical Equipment provider specializing in CPAP & BiPAP machines, masks, and supplies in Sarasota, FL",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "2079 Global Ct",
    "addressLocality": "Sarasota",
    "addressRegion": "FL",
    "postalCode": "34240",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "27.3364",
    "longitude": "-82.5307"
  },
  "url": import.meta.env.VITE_SITE_URL,
  "telephone": "(941) 555-0123",
  "medicalSpecialty": "Sleep Medicine Equipment",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "10:00",
      "closes": "16:00"
    }
  ],
  "areaServed": {
    "@type": "City",
    "name": "Sarasota",
    "addressRegion": "FL",
    "addressCountry": "US"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "CPAP & BiPAP Equipment",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "CPAP Machines",
          "description": "ResMed AirSense and other CPAP machines for sleep apnea treatment"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "BiPAP Machines",
          "description": "BiPAP machines for advanced sleep therapy treatment"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "CPAP Masks",
          "description": "F20, F40, P10 and other CPAP masks and accessories"
        }
      }
    ]
  }
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "MediMar Medical Market",
  "url": import.meta.env.VITE_SITE_URL,
  "logo": `${import.meta.env.VITE_SITE_URL}/logo.png`,
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "(941) 555-0123",
    "contactType": "customer service",
    "areaServed": "US",
    "availableLanguage": "English"
  },
  "sameAs": [
    "https://www.facebook.com/medimar",
    "https://www.linkedin.com/company/medimar"
  ]
};
